import Axios from 'axios';

function downloadURI(uri: string, name: string, authorization?: string) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', uri, true);
  authorization && xhr.setRequestHeader('Authorization', authorization);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement('a');
    tag.href = imageUrl;
    tag.download = name;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

export async function downloadURIPromise(url: string, name: string, authorization?: string) {
  await Axios({
    url,
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: authorization || '',
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

export default downloadURI;
